import { sanitizeBotFilename } from '../../sim/botProfile/index.ts';
import { confirmDialog, type ConfirmOptions } from '../editor/dialog.tsx';
import { setPanel } from '../panels.ts';

export { confirmDialog };
export type { ConfirmOptions };

/** Asks for a `bots/<name>.json` basename. Empty or invalid names cancel. */
export function promptBotFilename(defaultValue: string): Promise<string | null> {
  return new Promise((resolve) => {
    const settle = (value: string | null): void => {
      setPanel('editorDialog', null);
      resolve(value);
    };

    setPanel('editorDialog', {
      title: 'Save bot',
      message:
        'Writes bots/<name>.json in this repo. Later Saves update that file without a dialog.',
      confirmLabel: 'Save',
      cancelLabel: 'Cancel',
      inputDefault: defaultValue.replace(/\.json$/i, ''),
      inputLabel: 'File name',
      onConfirm: (value) => settle(sanitizeBotFilename(value)),
      onCancel: () => settle(null),
    });
  });
}
